import {
    Box, Icon, IconButton, Divider, Switch,
    Menu, MenuItem, ListItemIcon, Stack, Typography
} from '@mui/material'

import { useState, useRef } from 'react'

import { useNavigate } from 'react-router-dom'
import { useMsal } from '@azure/msal-react'

import { generateUrl } from '@services/routes'
import { ROUTE_HOME } from '@features/routes'

import Styles from '@components/Layout/Header/style'
import Link from '@components/Link'

const DARK_MODE = 'dark'
const LIGHT_MODE = 'light'

export const RightMenuHeader = () => {
    const darkMode = ((localStorage.getItem('theme.mode') ?? LIGHT_MODE) === DARK_MODE)

    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)
    const navigate = useNavigate()

    const { accounts } = useMsal()

    const email = accounts[0]?.username ?? '-';
    const name = accounts[0]?.name ?? '-';

    const item = useRef({
        padding: '16px',
        paddingTop: '8px',
        paddingBottom: '8px'
    })

    const handleThemeMode = () => {
        const newMode = (darkMode) ? LIGHT_MODE : DARK_MODE
        localStorage.setItem('theme.mode', newMode)
        location.reload()
    }

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleLogout = () => {
        handleClose()
        sessionStorage.clear()
        navigate(generateUrl(ROUTE_HOME))
        location.reload(true)
    }

    return (
        <Box sx={Styles.menu} whiteSpace={4}>
            <IconButton onClick={handleOpenMenu}>
                <Icon sx={Styles.rightIconFilled}>account_circle</Icon>
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{sx:{mt: '24px', borderRadius: '8px'}}}
                MenuListProps={{sx:{minWidth: '320px'}}}
            >
                <Box sx={item.current}>
                    <Stack direction={'column'} alignItems={'center'} gap={1}>
                        <Typography variant={'h5'} sx={{fontWeight: 600}}>{name}</Typography>
                        <Typography sx={{fontWeight: 400, fontSize: '12px'}}>{email}</Typography>
                        <Link href={'https://digitalplatforms.totalenergies.com/'} target={'blank'} external sx={{fontSize: '14px', fontWeight: 400}}>Digital Platforms Portal</Link>
                    </Stack>
                </Box>
                <Divider />
                <Box sx={item.current}>
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                        <Typography>Dark theme</Typography>
                        <Switch checked={(darkMode)} onChange={handleThemeMode} />
                    </Stack>
                </Box>
                <Divider />
                <MenuItem onClick={handleLogout} sx={{mt: '8px'}}>
                    <ListItemIcon>
                        <Icon>logout</Icon>
                    </ListItemIcon>
                    Log out
                </MenuItem>
            </Menu>
        </Box>
    )
}

export default RightMenuHeader